export default __webpack_public_path__ + "static/media/vub.9ac4643d.jpg";